import { ElMessage } from 'element-plus'
import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    employees: []
  }),
  mutations: {
    SET_EMPLOYEES(state, employees) {
      state.employees = employees
    },
    setEmployees(state, list) {
      state.employees = list
    }
  },
  actions: {
    async getUsers({ commit }) {
      const res = await apiClient('users.get')
      if (res?.list) {
        commit('SET_EMPLOYEES', res.list)
      }
    },
    async createUser({ commit, rootState }, payload) {
      try {
        payload.account_id = rootState.account_id
        const res = await apiClient('users.create', payload)
        if (res?.list) {
          commit('SET_EMPLOYEES', res.list)
        }
        return false
      } catch (e) {
        ElMessage.error('Ошибка добавления пользователя')
        return false
      }
    },
    async updateUser({ commit, rootState }, payload) {
      try {
        payload.account_id = rootState.account_id
        const res = await apiClient('users.update', payload)
        if (res?.list) {
          commit('SET_EMPLOYEES', res.list);
          return true
        }
        ElMessage.error(res?.error || 'Ошибка обновления пользователя')
        return false
      } catch (e) {
        ElMessage.error('Ошибка обновления пользователя')
        return false
      }
    },
    async deleteUser({ commit, rootState }, { id }) {
      try {
        const res = await apiClient('users.delete', { id, account_id: rootState.account_id })
        if (res?.list) {
          commit('SET_EMPLOYEES', res.list)
          ElMessage.success('Пользователь удалён')
          return true
        }
        ElMessage.error(res?.error || 'Ошибка удаления пользователя')
        return false
      } catch (e) {
        ElMessage.error('Ошибка удаления пользователя')
        return false
      }
    }
  },
  getters: {
    employees: state => state.employees
  }
}
